var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0488 6.27732L24.0879 24.957C23.7891 26.2754 23.0098 26.6035 21.9023 25.9824L15.8672 21.5351L12.9551 24.3359C12.6328 24.6582 12.3633 24.9277 11.7422 24.9277L12.1758 18.7812L23.3613 8.6738C23.8476 8.24021 23.2558 7.99997 22.6055 8.43357L8.77733 17.1406L2.82421 15.2773C1.52929 14.873 1.50585 13.9824 3.09374 13.3613L26.3789 4.3906C27.457 3.9863 28.4004 4.63083 28.0488 6.27732Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram_.e09305e1875fbd15d3f2f2e05afea937.svg";
export { ForwardRef as ReactComponent };